// extracted by mini-css-extract-plugin
export default {"icon":"SelectFromCloudSearch__icon--1XGcC"};